import React from 'react';
import { useState } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

const transform = (text) => {
    const temp = text.split('_');
    let ret = "";
    temp.forEach((txt) => {
        ret += " " + txt.charAt(0).toUpperCase() + txt.slice(1);
    })
    return ret;
}

export default function TableView(
    {
        data,
        edit,
        remove,
        columnNotShow = [],
        dateColumn = [],
        sortColumn = [],
        orderBy = null,
        setOrderBy = null,
        status=null,
        actions=true
    }) {
    const [id, setId] = useState(-1);
    const [modalDelete, setModalDelete] = useState(false);

    const deleteConfirm = (id) => {
        remove(id);
        setModalDelete(false);
    }

    const cancelConfirm = () => {
        setModalDelete(false);
    }

    const handleSort = (column) => {
        if (orderBy) {
            const temp = {};
            if (Object.keys(orderBy)[0] === column) {
                if (orderBy[column] === 'ASC') {
                    temp[column] = "DESC";
                } else {
                    temp[column] = "ASC";
                }
            } else {
                temp[column] = "ASC";
            }
            setOrderBy(temp);
        }
    }
    const tdNotShow = [...columnNotShow, ...dateColumn]
    var statusVar;
    return (
        <>
            {
                !data[0] ?
                    (
                        <LoadingScreen />
                    ) : (
                        <Table responsive striped bordered hover className='ms-2'>
                            <thead>
                                <tr>{
                                    Object.keys(data[0]).map((s, index) => {
                                        if (!columnNotShow?.includes(s)) {
                                            return (
                                                <th
                                                    key={index}
                                                    style={{ ...(orderBy && Object.keys(orderBy)[0] === s) ? { color: '#48cae4' } : {}, ...sortColumn.includes(s) ? { cursor: 'pointer' } : {} }}
                                                    onClick={() => {
                                                        if (sortColumn) {
                                                            if (sortColumn.includes(s)) {
                                                                handleSort(s)
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {transform(s)}
                                                    {sortColumn && sortColumn.includes(s) &&
                                                        <i class={`bx ${orderBy[s] === "ASC" ? 'bx-sort-down': 'bx-sort-up'}  `}></i>
                                                        // <img src={orderBy[s] === "ASC" ? sortDesc : sortAsc} />
                                                    }
                                                </th>)
                                        }
                                    })
                                }
                                    {
                                        status &&
                                        <th>Status</th>
                                    }
                                    {actions &&
                                        <th className='border-start text-end'>Actions</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map((row, index) => (
                                        <tr className='border-bottom' key={index}>
                                            {Object.entries(row).map(([k,v],i)=>
                                            {
                                                if(!tdNotShow?.includes(k)){
                                                    if(status?.column === k){
                                                        statusVar = v;
                                                    }
                                                    return (<td className='border-bottom-0' key={i}>{v}</td>)
                                                }
                                                if(dateColumn?.includes(k)){
                                                    if(v){
                                                        const dateFormat = new Date(v);
                                                        return (<td className='border-bottom-0' key={i}>{dateFormat.toDateString()}</td>)
                                                    }else{
                                                        return (<td className='border-bottom-0' key={i}></td>)
                                                    }
                                                    
                                                }
                                                // return (<td className='border-bottom-0' key={i}>{v}</td>)
                                            }
                                            )}
                                            {
                                                status &&
                                                <td className={`border-bottom-0 ${status.style?status.style(statusVar):""}`} >{status.format(statusVar)}</td>
                                            }
                                            <td className='text-end'>
                                                {edit && <i style={{ cursor: 'pointer' }} class='bx bx-edit fs-4' onClick={() => edit(row['id'])}></i>}
                                                {remove && <i style={{ cursor: 'pointer' }} class='bx bx-trash fs-4' onClick={() => { setModalDelete(true); setId(row['id']) }} ></i>}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    )}
            <Modal show={modalDelete} onHide={cancelConfirm} animation={true} centered>
                <Modal.Header>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <span className='d-flex justify-content-center pb-4'>Do you really want to delete?</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        <span className='w-100 d-flex justify-content-center align-items-center text-secondary p-2 border-2 border-secondary' style={{ cursor: 'pointer', border: '2px solid rgba(151, 156, 162, 1)', borderRadius: '6px' }} onClick={cancelConfirm}>Cancel</span>
                        <Button className='w-100' onClick={() => deleteConfirm(id)} >Delete</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}